import { render, staticRenderFns } from "./PortalTimelineItemComponent.vue?vue&type=template&id=09eaa459&"
import script from "./PortalTimelineItemComponent.vue?vue&type=script&lang=ts&"
export * from "./PortalTimelineItemComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports